import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ObjectivePane from 'components/objectives/ObjectivePane';
import BasePage from 'components/UI/BasePage';
import { useGetObjectivesQuery } from 'services/objectives/api';
import links, { matchesLinkKey } from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const ObjectivePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string; }>();
  const { data: objectives } = useGetObjectivesQuery();
  const objective = objectives && objectives.find(item => matchesLinkKey(item, slug));

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{`${t('objectives')}${objective?.name ? ` - ${objective.name}` : ''}`}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.objectives, navigate), label: t('objectives') },
            { label: objective?.name ?? '' },
          ]}
        />
        {
          slug && (
            <ObjectivePane
              id={slug}
              showExpandIcon={false}
            />
          )
        }
      </BasePage>
    </>
  );
};

export default ObjectivePage;
